export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 1_02.af3dff28.jpg";